import React from "react";
import { type PageThemeBase, type ThemeRenderingParameters } from "../generated-types";
import { useSitecoreContext } from "~/foundation/Jss";
import { type ColorThemeId } from "..";
import { ColorThemeProvider } from "../ColorThemeContext";
import { getColorTheme } from "./themable";

type ThemableProps = {
	params?: ThemeRenderingParameters;
	rendering: {
		componentName: string;
	}
}


type WithThemeProps = {
	fallbackToPageTheme?: boolean;
}

// https://stackoverflow.com/questions/40510611/typescript-interface-require-one-of-two-properties-to-exist


export function withFooterTheme({ fallbackToPageTheme = false }: WithThemeProps) {

	return function WithThemeInputComponent<P extends object>(InputComponent: React.ComponentType<P>) {

		const withFooterTheme = (props: P & ThemableProps) => {
			const { sitecoreContext } = useSitecoreContext<PageThemeBase>();
			const isRtl = sitecoreContext?.custom.settings.isRtl || false;
			const footerColorTheme = getColorTheme(sitecoreContext.route?.fields?.footerColorTheme?.value as ColorThemeId, isRtl);

			if (!footerColorTheme && fallbackToPageTheme) {
				const pageTheme = getColorTheme(sitecoreContext.route?.fields?.colorTheme?.value as ColorThemeId, isRtl);
				if (pageTheme) {
					return (
						<ColorThemeProvider colorTheme={pageTheme} componentName={props.rendering.componentName}>
							<InputComponent {...props} />
						</ColorThemeProvider>
					);
				}
			} else if (footerColorTheme) {
				return (
					<ColorThemeProvider colorTheme={footerColorTheme} componentName={props.rendering.componentName}>
						<InputComponent {...props} />
					</ColorThemeProvider>
				);
			}

			return <InputComponent {...props} />;
		}

		withFooterTheme.displayName = "WithFooterTheme";

		return withFooterTheme;
	}
}